import { Modal } from "@mui/material";
import BasicButton from "components/BasicInputs/BasicButton";
import Portal from "components/Portal";
import ModalBox from "components/Shared/Modals/ModalBox";
import { useState } from "react";
import PermissionsView from "./PermissionsView";
import { apiGetPermissions } from "../../../api/roleApi";

export interface PermissionsViewButtonProps {
  role: Role;
  permissions: Permission[];
  getRolePermissions?: (roleId:number) => void
}
export default function PermissionsViewButton({ permissions, role, getRolePermissions }: PermissionsViewButtonProps) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <BasicButton onClick={() => {
        if (getRolePermissions) {
          getRolePermissions(role.id);
        }
        setOpen(true);
      }}>مشاهده دسترسی ها</BasicButton>
      <Portal>
        <Modal open={open}>
          <ModalBox
            title={`دسترسی های کاربران "${role.fa_title || ""}"`}
            onClose={() => setOpen(false)}
            style={{ container: { maxWidth: "100vw", width: 600 } }}
          >
            <PermissionsView permissions={permissions} />
          </ModalBox>
        </Modal>
      </Portal>
    </>
  );
}
